import { createReducer } from './utilities.js';
import { persistReducer } from 'redux-persist';
import buildPersistConfig from './buildPersistConfig.js';

const createPersistedReducer = (initialState, reducerMap, persistConfig) => {
  const reducer = createReducer(initialState, reducerMap);
  return persistReducer(buildPersistConfig(persistConfig.key, persistConfig), reducer);
};

export default createPersistedReducer;
